import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

// smell: open self-registration linked from `LoginForm.tsx:100`; prefer disabling
// or gating it over deleting it.
/**
 * @purpose-exempt open self-registration, no persona self-registers; disable or gate
 */
export const Route = createFileRoute("/_public/register")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
